@if (isLoading) {
  <mds-loader></mds-loader>
}
<div class="request-container">
  @if (!isLoading) {
    <article class="request">
      @switch (response?.plugin_id) {
        @case (questionnaireTypes.PCF_QUESTIONNAIRE) {
          <ng-container *ngTemplateOutlet="pcfQuestionnaire" />
        }
        @case (questionnaireTypes.EPD_QUESTIONNAIRE) {
          <ng-container *ngTemplateOutlet="pcfQuestionnaire" />
        }
        @case (questionnaireTypes.COMPLIANCE_QUESTIONNAIRE) {
          @if (threadApiCompleted) {
            <app-compliance-questionnaire
              [response]="response"
              [threads]="threads"
              (gridReady)="onGridReady($event)"
              [rid]="rid"
              [errors]="errorMessages"
            ></app-compliance-questionnaire>
          }
        }
        @case (questionnaireTypes.CBAM_STEEL_QUESTIONNAIRE) {
          <ng-container *ngTemplateOutlet="cbamQuestionnaire" />
        }
        @case (questionnaireTypes.CBAM_ALUM_QUESTIONNAIRE) {
          <ng-container *ngTemplateOutlet="cbamQuestionnaire" />
        }
        @case (questionnaireTypes.SCIP_QUESTIONNAIRE) {
          @if (threadApiCompleted) {
            <app-scip-questionnaire [response]="response" [threads]="threads" [rid]="rid"></app-scip-questionnaire>
          }
        }
        @default {
          <app-info-tiles [data]="response" (reload)="init()"></app-info-tiles>
          <app-question-tile *ngIf="response?.questions" [data]="response" (reload)="init()"></app-question-tile>
          <!-- <app-info-request *ngIf="response?.substances" [data]="response" [rid]="rid"></app-info-request> -->
          <!-- <app-compliance-statement *ngIf="response?.compliance" [data]="response" [rid]="rid"></app-compliance-statement> -->
        }
      }
    </article>
  }
</div>

<ng-template #pcfQuestionnaire>
  <pcf-questionnaire
    (reload)="init()"
    [materialBreakdown]="response.material_breakdown"
    [productInfo]="response.product_related_information"
    [reporting]="response.product_footprint_calculation_reporting"
    [results]="response.results"
    [rid]="rid"
    [title]="response?.title"
  ></pcf-questionnaire>
</ng-template>
<ng-template #cbamQuestionnaire>
  <app-cbam-questionnaire [data]="response" [rid]="rid"></app-cbam-questionnaire>
</ng-template>

<ng-template #errorDialogBody>
  <div class="error-dialog-body">
    <ul class="error-list">
      @for (error of errorMessages; track error.message; let i = $index) {
        <li class="mk-paragraph">{{ error.message }}</li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #errorDialogActions>
  <mds-button type="secondary" (click)="errorDialogRef?.close(false)">Back to questionnaire</mds-button>
</ng-template>
